export default [
  {
    path: "/consult/add",
    component: () => import("../pages/consult/add.vue")
  }
]



// WEBPACK FOOTER //
// ./src/router/consult.js